module.exports = __webpack_public_path__ + "img/1.bfa23f3e.png";